import { Loading } from "@components"
import { FEATURE } from "@constants"
import { AdminDashboardContainer } from "@containers"
import { hasFeature } from "@helpers/dashboard"
import { useGetFeatures } from "@hooks"
import { Navigate } from "react-router-dom"

const AdminDashboard = () => {
  const { isLoading, data: featureList } = useGetFeatures()
    const isEnabled = hasFeature(featureList, FEATURE.ADMIN_DASHBOARD)

  if (isLoading) {
    return <Loading />
  }

  return isEnabled ? <AdminDashboardContainer /> : <Navigate to='/' />
}

export default AdminDashboard